export default __webpack_public_path__ + "static/Allie-5cb914b3576b630a88f7140f32f1697f.jpeg";